
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'


@Component({
  components: {},

})
export default class CourseList extends Vue {
    @Prop() is_weight_show: boolean
    srot_list: any = [
      {
        color: '#F33030',
        id: 3
      },
      {
        color: '#ECC647',
        id: 2
      },
      {
        color: '#2ED05E',
        id: 1
      },
      {
        color: '#FFFFFF',
        id: 0
      }
    ]
    getSort(val) {
      this.$emit('select-sort', val)
    }
    mounted() {}
}
